import { WordMat } from '@/common/types/wordMat';
import { getCardColor } from '@/dashboard/WordMat/colors';
import { SquaresFourIcon } from '@phosphor-icons/react';
import { cn } from '@shadcn/lib/utils';

interface WordMatPreviewProps {
  wordMat: WordMat;
  className?: string;
}

export default function WordMatPreview({
  wordMat,
  className,
}: WordMatPreviewProps) {
  const cardColor = getCardColor(wordMat.id);

  return (
    <div
      className={cn(
        'relative flex items-center justify-center',
        cardColor,
        className,
      )}
    >
      {/* Icon in bottom left corner */}
      <SquaresFourIcon
        size={24}
        weight="duotone"
        className="absolute bottom-2 left-2 text-gray-600 opacity-60"
      />
    </div>
  );
}
